import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import { isArmorType } from '@/types/lootTypes';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import LootArmorProperties from './LootArmorProperties.vue';
import BackButton from '@/components/BackButton.vue';
const equipmentModule = namespace('equipment');
let LootArmor = class LootArmor extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Armor';
    }
    created() {
        this.fetchEquipment();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.equipment)
            .filter(isArmorType)
            .map(equipment => ({
            ...equipment,
            id: equipment.name,
            isExpandable: true
        })).value();
    }
    filterProperties(propertiesMap, filterValue) {
        var x = Object.keys(propertiesMap);
        var y = _.intersection(x, filterValue);
        return y.length;
    }
    get properties() {
        return _(this.items).map(({ propertiesMap }) => (Object.keys(propertiesMap))).flattenDeep().compact().sortBy().uniq().value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name', render: _.startCase },
            {
                text: 'Type',
                value: 'armorClassification',
                filterChoices: ['Light', 'Medium', 'Heavy', 'Shield'],
                filterFunction: ({ armorClassification }, filterValue) => armorClassification === filterValue
            },
            {
                text: 'Property',
                value: 'propertiesMap',
                isMultiSelect: true,
                render: (propertiesMap) => Object.values(propertiesMap).map((property) => _.upperFirst(property)).join(', '),
                filterChoices: this.properties,
                filterFunction: ({ propertiesMap }, filterValue) => this.filterProperties(propertiesMap, filterValue)
            },
            { text: 'Cost', value: 'cost' },
            { text: 'Weight', value: 'weight' },
            { text: 'AC', value: 'ac' },
            { text: 'Stealth', value: 'stealthDisadvantage', render: (isDisadvantage) => isDisadvantage ? 'Disadvantage' : '-' },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    equipmentModule.State
], LootArmor.prototype, "equipment", void 0);
__decorate([
    equipmentModule.Action
], LootArmor.prototype, "fetchEquipment", void 0);
LootArmor = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            LootArmorProperties,
            VueMarkdown
        }
    })
], LootArmor);
export default LootArmor;
